<template>
  <scoped v-if="customer">
    <h1>
      Customer
    </h1>
    <table>
      <tbody>
        <tr>
          <th>
            Type
          </th>
          <td>
            {{ customer.type }}
          </td>
        </tr>
        <tr>
          <th>
            Number
          </th>
          <td>
            {{ customer.number }}
          </td>
        </tr>
        <tr>
          <th>
            Name
          </th>
          <td>
            {{ customer.name }}
          </td>
        </tr>
        <tr>
          <th>
            Memorandum
          </th>
          <td>
            {{ customer.memorandum }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="customer.contactDetails && customer.contactDetails.records">
      <h2>
        Contact Details
      </h2>
      <ContactDetailsList 
        v-model:selectedIndex="selectedContactDetailsIndex"
        :items="customer.contactDetails.records"
        readOnly
      />
      <ContentModal v-if="selectedContactDetailsIndex != null">
        <ContactDetailsEditor
          :value="customer.contactDetails.records[selectedContactDetailsIndex]"
          readOnly
        />
        <br>
        <Button
          title="Close"
          @click="selectedContactDetailsIndex = null"
        />
      </ContentModal>
    </div>
    <div v-if="customer.orders && customer.orders.records">
      <h2>
        Orders
      </h2>
      <OrderList
        v-model:selectedIndex="selectedOrderIndex"
        :items="customer.orders.records"
      />
      <ContentModal v-if="selectedOrderIndex != null">
        <SaleOrderEditor
          :value="customer.orders.records[selectedOrderIndex]"
          readOnly
        />
        <br>
        <Button
          title="Close"
          @click="selectedOrderIndex = null"
        />
      </ContentModal>
    </div>
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import Button from "@/components/button.vue"
  import ContentModal from "@/components/modals/content.vue"
  import ContactDetailsEditor from  "@/components/editors/contact_details.vue"
  import ContactDetailsList from  "@/components/lists/contact_details.vue"
  import {Customer as CustomerClient} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import {onBeforeMount, ref} from "vue"
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import OrderList from "@/components/lists/order.vue"
  import SaleOrderEditor from "@/components/editors/sale_order.vue"

  const props = defineProps({
    customerID: {
      default: null,
      required: true,
      type: String
    }
  })

  const error = ref<Error>(null)
  const customerClient = new CustomerClient()
  const customer = ref<Customer>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const selectedOrderIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      customer.value = await customerClient.summary(props.customerID)
    } catch(e) {
      error.value = e
    }
  }
</script>
